import { lazy } from 'react';
import { ROUTES } from './constants';

const AffiliateLinks = lazy(() => import('../pages/AffiliateLinks'));
const SelectProductsPage = lazy(() => import('../pages/AffiliateLinks/SelectProductsPage'));
const CreateLinkPage = lazy(() => import('../pages/AffiliateLinks/CreateLinkPage'));
const CreateLandingPage = lazy(() => import('../pages/AffiliateLinks/CreateLandingPage'));
const CreateWidgetPage = lazy(() => import('../pages/AffiliateLinks/CreateWidgetPage'));
const SelectBannerPage = lazy(() => import('../pages/AffiliateLinks/SelectBannerPage'));
const Dashboard = lazy(() => import('../pages/Dashboard'));
const Income = lazy(() => import('../pages/Income'));
const GeneralStatisticsRoute = lazy(() => import('../pages/Income/routes/GeneralStatisticsRoute'));
const IncomeDetailsRoute = lazy(() => import('../pages/Income/routes/IncomeDetailsRoute'));
const InvoicesRoute = lazy(() => import('../pages/Income/routes/InvoicesRoute'));
const InvoiceDetailPage = lazy(() => import('../pages/Income/components/Invoices/InvoiceDetails'));
const Media = lazy(() => import('../pages/Media'));
const Advertisers = lazy(() => import('../pages/Advertisers'));
const AdvertiserDetail = lazy(() => import('../pages/Advertisers/AdvertiserDetail'));
const PerformanceReport = lazy(() => import('../pages/Performance'));
const LinkPerformanceRoute = lazy(() => import('../pages/Performance/routes/LinkPerformanceRoute'));
const OverviewRoute = lazy(() => import('../pages/Performance/routes/OverviewRoute'));
const ProductsRoute = lazy(() => import('../pages/Performance/routes/ProductsRoute'));
const NotFound = lazy(() => import('../pages/NotFound/Index'));
const Profile = lazy(() => import('../pages/Profile'));
const Tickets = lazy(() => import('../pages/Tickets'));

export interface AppRoute {
  path: string;
  title: string;
  element: JSX.Element;
  private: boolean;
  children?: AppRoute[];
}

export const appRoutes: AppRoute[] = [
  {
    path: ROUTES.DASHBOARD.path,
    title: ROUTES.DASHBOARD.title,
    element: <Dashboard />,
    private: true,
  },
  {
    path: ROUTES.MEDIA.path,
    title: ROUTES.MEDIA.title,
    element: <Media />,
    private: true,
  },
  {
    path: ROUTES.AFFILIATE_LINKS.path,
    title: ROUTES.AFFILIATE_LINKS.title,
    element: <AffiliateLinks />,
    private: true,
    children: [
      {
        path: ROUTES.AFFILIATE_LINKS_SELECT_PRODUCTS.path,
        title: ROUTES.AFFILIATE_LINKS_SELECT_PRODUCTS.title,
        element: <SelectProductsPage />,
        private: true,
      },
      {
        path: ROUTES.AFFILIATE_LINKS_CREATE_LINK.path,
        title: ROUTES.AFFILIATE_LINKS_CREATE_LINK.title,
        element: <CreateLinkPage />,
        private: true,
      },
      {
        path: ROUTES.AFFILIATE_LINKS_CREATE_LANDING.path,
        title: ROUTES.AFFILIATE_LINKS_CREATE_LANDING.title,
        element: <CreateLandingPage />,
        private: true,
      },
      {
        path: ROUTES.AFFILIATE_LINKS_CREATE_WIDGET.path,
        title: ROUTES.AFFILIATE_LINKS_CREATE_WIDGET.title,
        element: <CreateWidgetPage />,
        private: true,
      },
      {
        path: ROUTES.AFFILIATE_LINKS_SELECT_BANNER.path,
        title: ROUTES.AFFILIATE_LINKS_SELECT_BANNER.title,
        element: <SelectBannerPage />,
        private: true,
      },
    ],
  },
  {
    path: ROUTES.ADVERTISERS.path,
    title: ROUTES.ADVERTISERS.title,
    element: <Advertisers />,
    private: true,
  },
  {
    path: ROUTES.ADVERTISER_DETAIL.path,
    title: ROUTES.ADVERTISER_DETAIL.title,
    element: <AdvertiserDetail />,
    private: true,
  },
  {
    path: ROUTES.INCOME.path,
    title: ROUTES.INCOME.title,
    element: <Income />,
    private: true,
    children: [
      {
        path: ROUTES.INCOME_GENERAL.path,
        title: ROUTES.INCOME_GENERAL.title,
        element: <GeneralStatisticsRoute />,
        private: true,
      },
      {
        path: ROUTES.INCOME_DETAIL.path,
        title: ROUTES.INCOME_DETAIL.title,
        element: <IncomeDetailsRoute />,
        private: true,
      },
      {
        path: ROUTES.INCOME_INVOICES.path,
        title: ROUTES.INCOME_INVOICES.title,
        element: <InvoicesRoute />,
        private: true,
      },
    ],
  },
  {
    path: ROUTES.PERFORMANCE.path,
    title: ROUTES.PERFORMANCE.title,
    element: <PerformanceReport />,
    private: true,
    children: [
      {
        path: ROUTES.PERFORMANCE_LINKS.path,
        title: ROUTES.PERFORMANCE_LINKS.title,
        element: <LinkPerformanceRoute />,
        private: true,
      },
      {
        path: ROUTES.PERFORMANCE_OVERVIEW.path,
        title: ROUTES.PERFORMANCE_OVERVIEW.title,
        element: <OverviewRoute />,
        private: true,
      },
      {
        path: ROUTES.PERFORMANCE_PRODUCTS.path,
        title: ROUTES.PERFORMANCE_PRODUCTS.title,
        element: <ProductsRoute />,
        private: true,
      },
    ],
  },
  {
    path: ROUTES.INVOICE_DETAIL.path,
    title: ROUTES.INVOICE_DETAIL.title,
    element: <InvoiceDetailPage />,
    private: true,
  },
  {
    path: ROUTES.PROFILE.path,
    title: ROUTES.PROFILE.title,
    element: <Profile />,
    private: true,
  },
  {
    path: ROUTES.TICKETS.path,
    title: ROUTES.TICKETS.title,
    element: <Tickets />,
    private: true,
  },
  {
    path: ROUTES.NOT_FOUND.path,
    title: ROUTES.NOT_FOUND.title,
    element: <NotFound />,
    private: false,
  },
];
